module.exports = __webpack_public_path__ + "img/motorway_6x4_z18.846eac62.svg";